import styled from 'styled-components';

export const Icon = styled.img`
  margin: 1px 0 0 4px;
  vertical-align: top;
`;
